import { FileParseFormatDto, GetDefaultFileParseFormatDto } from './FileParseFormatDto';

export interface FileParseFormatRankingDto {
  Format: FileParseFormatDto;
  MatchedRequiredColumns: number;
  MissingRequiredColumns: number;
  MatchedColumns: number;
  MissingColumns: number;
  ExtraColumns: number;
}

export class FileParseFormatRankingDto implements FileParseFormatRankingDto {
  Format = GetDefaultFileParseFormatDto();

  get MatchPercentage(): number {
    let totalColumns = this.MatchedColumns + this.MissingColumns;
    return totalColumns === 0 ? 0 : this.MatchedColumns / totalColumns;
  }
}
